import { ItemList as ItemListUI } from "@business-finland/wif-ui-lib";
import { useRouter } from "next/router";
import { useMemo } from "react";
import Head from "next/head";

import { jcrMultiFieldToArray, resolveLinkSwitchableField } from "../../../util/magnolia";
import {
  generateItemListSchema,
  generateHowToSchema,
} from "../../../service/schemaOrg/generators/itemList";
import type { IItemListProps } from "./types";
import HtmlParser from "@/components/HtmlParser";

export function ItemList(props: IItemListProps): JSX.Element | null {
  const { locale } = useRouter();
  const { isPreview } = useRouter();

  const items = useMemo(
    () =>
      jcrMultiFieldToArray(props.items).map((item) => ({
        id: item["@id"],
        title: item.title,
        description: item.description,
        linkHref: resolveLinkSwitchableField(item.link, isPreview).linkHref,
        isExternalLink: resolveLinkSwitchableField(item.link, isPreview).isExternalLink,
      })),
    [props.items, isPreview]
  );

  if (items.length === 0) return null;

  // Generate schema based on schemaType
  let schema = null;
  if (props.schemaType === "itemList") {
    schema = generateItemListSchema(
      items,
      props.title,
      undefined,
      locale || "en"
    );
  } else if (props.schemaType === "howTo") {
    schema = generateHowToSchema(
      items,
      props.title,
      undefined,
      locale || "en"
    );
  }

  const itemsProcessed = items.map((item) => ({
    ...item,
    description: item.description ? <HtmlParser html={item.description} /> : undefined,
  }));

  return (
    <>
      {schema && (
        <Head>
          <script
            type="application/ld+json"
            nonce={process.env.NEXT_PUBLIC_SCRIPT_NONCE}
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        </Head>
      )}
      <ItemListUI
        id={props.anchorTag}
        title={props.title}
        listType={props.listType}
        schemaType={props.schemaType}
        items={itemsProcessed}
      />
    </>
  );
}

